import { client } from "api";

export type ReviewOrderRequest = {
  orderNr: string;
};

export type ReviewOrderResponse = void;

export const reviewOrder = ({ orderNr }: ReviewOrderRequest) =>
  client
    .post<ReviewOrderResponse>(`/order/${orderNr}/review`).then((res) => res.data);
